import { OrganizationIdentifierScheme } from '@debbie/common/dist/customers/types.js';
import React from 'react';
import { Col, Row } from './Grid/index.js';
import Input from './Input.js';
import Select from './Select.js';
const RegistryIdentifierInput = (props) => {
    const scheme = props.value?.scheme || OrganizationIdentifierScheme.DK_CVR;
    return (React.createElement(Row, null,
        React.createElement(Col, { size: "md", width: "5" },
            React.createElement(Select, { value: scheme, disabled: props.disabled, onChange: (e) => props.onChange({
                    scheme: e.target.value,
                    value: props.value?.value || '',
                }) }, Object.values(OrganizationIdentifierScheme).map((schemeOption) => (React.createElement("option", { key: schemeOption, value: schemeOption }, schemeOption))))),
        React.createElement(Col, { size: "md", width: "7" },
            React.createElement(Input, { value: props.value?.value || '', disabled: props.disabled, 
                // The part after the colon reads as a natural placeholder, e.g. CVR or ORGNR
                placeholder: props.placeholder || scheme.split(':').pop(), onChange: (e) => props.onChange({
                    scheme,
                    value: e.target.value,
                }) }))));
};
export default RegistryIdentifierInput;
//# sourceMappingURL=RegistryIdentifierInput.js.map